import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Networks from './Networks';
import SuppliersList from './SupplierList';

// TODO: Almost the same as BB SuppliersTab (except for networks), consider extracting common component
export default class SuppliersTab extends Component {
    constructor(props) {
        super(props);

        this.init(props);
        this.state = this.getInitialState(props);

        this.selectAll = this.selectAll.bind(this);
        this.selectNone = this.selectNone.bind(this);
        this.onSupplierChecked = this.onSupplierChecked.bind(this);
        this.onChangeNetworkSelected = this.onChangeNetworkSelected.bind(this);
        this.onPersonalChange = this.onPersonalChange.bind(this);
        this.onBusinessChange = this.onBusinessChange.bind(this);

        this.onSelectionChanged = this.onSelectionChanged.bind(this);
    }

    init(props) {
        this.availableShortUrls = props.suppliers.filter(p => p.isAvailable).map(p => p.shortUrl);

        this.personalShortUrls = props.suppliers.filter(p => p.isAvailable && p.isPersonal).map(p => p.shortUrl);

        this.businessShortUrls = props.suppliers.filter(p => p.isAvailable && p.isBusiness).map(p => p.shortUrl);

        this.isPersonalAvailable = this.personalShortUrls.length > 0;
        this.isBusinessAvailable = this.businessShortUrls.length > 0;

        const allNetworks = [];
        props.suppliers.forEach(supplier => {
            supplier.networks.forEach(network => {
                if (!allNetworks.some(p => p.id === network.id)) {
                    allNetworks.push(network);
                }
            });
        });
        this.allNetworks = allNetworks;
        this.allNetworkIds = allNetworks.map(p => p.id);
    }

    getInitialState(props) {
        const customerType = props.customerType;
        const isPersonal = !customerType || customerType.toLowerCase() === 'personal';

        let isBusiness = !customerType || customerType.toLowerCase() === 'business';
        if (!this.isBusinessAvailable) isBusiness = false;

        let selectedShortUrls = props.selectedShortUrls || [];
        if (selectedShortUrls.length === 0) {
            if (isPersonal) {
                selectedShortUrls = selectedShortUrls.concat(this.personalShortUrls);
            }
            if (isBusiness) {
                selectedShortUrls = selectedShortUrls.concat(this.businessShortUrls);
            }
        }

        if (selectedShortUrls.length === 0) {
            if (props.selectedNetworkIds && props.selectedNetworkIds.length > 0) {
                selectedShortUrls = selectedShortUrls.concat(
                    props.suppliers
                        .filter(s => s.isAvailable && s.networks.some(n => props.selectedNetworkIds.indexOf(n.id) > -1))
                        .map(p => p.shortUrl)
                );
            }
        }

        return {
            selectedShortUrls: (selectedShortUrls || this.availableShortUrls).slice(),
            isPersonal: isPersonal,
            isBusiness: isBusiness,

            selectedNetworkIds:
                (props.selectedNetworkIds || []).length > 0 ? props.selectedNetworkIds : this.allNetworkIds
        };
    }

    onSupplierChecked(supplierId, checked) {
        const supplier = this.props.suppliers.filter(p => p.id === supplierId)[0];

        // Use .slice() to avoid modifying the source array
        let selectedShortUrls = this.state.selectedShortUrls.slice();
        if (checked) {
            selectedShortUrls.push(supplier.shortUrl);
        } else {
            selectedShortUrls = selectedShortUrls.filter(p => p !== supplier.shortUrl);
        }

        this.setState(
            {
                selectedShortUrls: selectedShortUrls,
                isPersonal: this.state.isPersonal || (checked && supplier.isPersonal),
                isBusiness: this.state.isBusiness || (checked && supplier.isBusiness)
            },
            this.onSelectionChanged
        );
    }

    onChangeNetworkSelected(networkId, checked) {
        const selectedShortUrls = this.state.selectedShortUrls.slice();
        this.props.suppliers
            .filter(s => s.isAvailable && s.networks.some(n => n.id === networkId))
            .map(p => p.shortUrl)
            .forEach(shortUrl => {
                this.AddRemoveItem(selectedShortUrls, shortUrl, checked);
            });

        const selectedNetworkIds = (this.state.selectedNetworkIds || this.allNetworkIds).slice();
        this.AddRemoveItem(selectedNetworkIds, networkId, checked);

        this.setState(
            {
                selectedNetworkIds: selectedNetworkIds,
                selectedShortUrls: selectedShortUrls
            },
            this.onSelectionChanged
        );
    }

    AddRemoveItem(items, item, add) {
        const index = items.indexOf(item);
        if (add) {
            if (index === -1) {
                items.push(item);
            }
        } else {
            if (index > -1) {
                items.splice(index, 1);
            }
        }
    }

    onPersonalChange() {
        const checked = !this.state.isPersonal;
        const selectedShortUrls = this.getSelectedUrlsForCustomerType(
            checked,
            this.personalShortUrls,
            this.state.isBusiness,
            this.businessShortUrls
        );

        this.setState(
            {
                isPersonal: checked,
                selectedShortUrls: selectedShortUrls
            },
            this.onSelectionChanged
        );
    }

    onBusinessChange() {
        const checked = !this.state.isBusiness;
        const selectedShortUrls = this.getSelectedUrlsForCustomerType(
            checked,
            this.businessShortUrls,
            this.state.isPersonal,
            this.personalShortUrls
        );

        this.setState(
            {
                isBusiness: checked,
                selectedShortUrls: selectedShortUrls
            },
            this.onSelectionChanged
        );
    }

    getSelectedUrlsForCustomerType(typeChecked, typeShortUrls, otherTypeChecked, otherTypeShortUrls) {
        if (typeChecked) {
            // Add
            return this.state.selectedShortUrls.concat(
                typeShortUrls.filter(p => this.availableShortUrls.some(a => a === p))
            );
        }

        return this.state.selectedShortUrls.filter(
            s =>
                // Exclude all of this type
                !typeShortUrls.some(p => p === s) ||
                // but keep for the other if it's checked
                (otherTypeChecked && otherTypeShortUrls.some(p => p === s))
        );
    }

    selectAll() {
        // Ignore, if all are already selected
        if (this.state.selectedShortUrls.length === this.availableShortUrls.length) {
            return;
        }

        this.setState(
            {
                selectedShortUrls: this.availableShortUrls,
                isPersonal: this.isPersonalAvailable && true,
                isBusiness: this.isBusinessAvailable && true,
                selectedNetworkIds: this.allNetworkIds
            },
            this.onSelectionChanged
        );
    }

    selectNone() {
        this.setState(
            {
                selectedShortUrls: [],
                isPersonal: false,
                isBusiness: false
            },
            this.onSelectionChanged
        );
    }

    onSelectionChanged() {
        if (!this.props.onSelectionChanged) {
            return;
        }

        const selectedShortUrls =
            this.state.selectedShortUrls.length === this.availableShortUrls.length ? [] : this.state.selectedShortUrls;

        const customerType =
            this.state.isPersonal && !this.state.isBusiness
                ? 'Personal'
                : this.state.isBusiness && !this.state.isPersonal
                  ? 'Business'
                  : null;

        const selectedNetworkIds =
            this.state.selectedNetworkIds.length === this.allNetworkIds.length ? [] : this.state.selectedNetworkIds;

        this.props.onSelectionChanged(selectedShortUrls, customerType, selectedNetworkIds);
    }

    render() {
        const all = this.props.suppliers;
        const availableSuppliers = all.filter(item => !!item.isAvailable).sort((a, b) => a.name.localeCompare(b.name));

        const resources = this.props.resources;
        return (
            <React.Fragment>
                <Networks
                    items={this.allNetworks}
                    selectedIds={this.state.selectedNetworkIds}
                    onChangeItemChecked={this.onChangeNetworkSelected}
                    resources={resources}
                />

                <div className="row  bor-b-1 pad-t-2 mar-b-3">
                    <div className="col-xs-24 col-sm-24 col-md-6">
                        <h5 className="font-5 mar-0 mar-b-4 mar-b-3-xs mar-b-3-sm">Select Carriers</h5>
                    </div>
                    <div className="col-xs-24 col-sm-24 col-md-18">
                        <ul className="mar-0 supplier-list block-grid-xs-2 block-grid-md-3">
                            <li>
                                <div className="checkbox-tick font-4">
                                    <input
                                        type="checkbox"
                                        id="personal-checkbox"
                                        checked={this.state.isPersonal}
                                        onChange={this.onPersonalChange}
                                        disabled={!this.isPersonalAvailable}
                                    />
                                    <label className="font-300 font-3-xs" htmlFor="personal-checkbox">
                                        <span>{resources.personal}</span>
                                    </label>
                                </div>
                            </li>
                            <li>
                                <div className="checkbox-tick font-4">
                                    <input
                                        type="checkbox"
                                        id="business-checkbox"
                                        checked={this.state.isBusiness}
                                        onChange={this.onBusinessChange}
                                        disabled={!this.isBusinessAvailable}
                                    />
                                    <label className="font-300 font-3-xs" htmlFor="business-checkbox">
                                        <span>{resources.business}</span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-24">
                        <div className="row">
                            <div className="col-xs-24  bor-b-1  pad-t-1  pad-b-3">
                                <a href="javascript:void(0)" id="select-all-suppliers" onClick={this.selectAll}>
                                    {resources.selectAll}
                                </a>
                                {` ${resources.or} `}
                                <a href="javascript:void(0)" id="unselect-all-suppliers" onClick={this.selectNone}>
                                    {resources.none}
                                </a>
                            </div>
                        </div>
                        {(() => {
                            if (availableSuppliers.length) {
                                return (
                                    <SuppliersList
                                        className="supplier-list mar-y-3 block-grid-xs-2  block-grid-md-4"
                                        items={availableSuppliers}
                                        selectedShortUrls={this.state.selectedShortUrls}
                                        onCheckedChanged={this.onSupplierChecked}
                                    />
                                );
                            }
                            return null;
                        })()}
                        {(() => {
                            const unavailableSuppliers = all.filter(s => !s.isAvailable);
                            if (unavailableSuppliers.length) {
                                return (
                                    <div className="col-xs-24 pad-y-2 bor-t-1 mar-t-2">
                                        <button
                                            className="btn btn-link btn-block"
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#collapseUnavailableProviders"
                                            aria-controls="collapseUnavailableProviders"
                                        >
                                            {resources.unavailableSuppliersInYourArea}{' '}
                                            <span className="fa fa-chevron-down font-5"></span>
                                        </button>
                                        <div className="collapse in" id="collapseUnavailableProviders">
                                            <SuppliersList
                                                className="supplier-list mar-y-3 block-grid-xs-2  block-grid-md-4"
                                                items={unavailableSuppliers}
                                                selectedShortUrls={this.state.selectedShortUrls}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

/* eslint-disable import/no-named-as-default-member */
SuppliersTab.propTypes = {
    resources: PropTypes.object,
    selectedShortUrls: PropTypes.arrayOf(PropTypes.string),
    selectedNetworkIds: PropTypes.arrayOf(PropTypes.number),
    customerType: PropTypes.string,
    hasAddress: PropTypes.bool,
    suppliers: PropTypes.arrayOf(PropTypes.object)
};
/* eslint-enable */
